const GoogleTagMngHandler = {

    DataLayerHandler: {
        
        test: function(data){
            return new Promise( (resolve, reject) => {
                if (window.dataLayer ){
                    console.log("DataLayer Push Event Test").then( (response) => { resolve(); });
                }
                else{
                    console.log("GTM test reject")
                    reject();
                }
            });
        },
        
        /*
         * @data Object
         */
        pushEvent: function(data=null){
            return new Promise( (resolve,reject) => {
                if (window.dataLayer && data!==null){
                    window.dataLayer.push(data);
                    resolve();
                }
                else{
                    reject();
                }
            });
        }        
    }
};

export default GoogleTagMngHandler
